export default __webpack_public_path__ + "static/media/icons-user.4dc33cde.svg";